import { createHttpEndpoint } from '../../utils'

import type {
  PostEmailVerificationRequest,
  PostEmailVerificationResponse,
  UserProfileData,
} from './types'

/**
 * Retrieve the status of client profile email verification
 */
export const getUserProfileData = createHttpEndpoint<UserProfileData>({
  method: 'GET',
  operationId: 'retrieveClientProfileEmailStatus',
  path: '/auth/public/v1/users',
})

/**
 * Start and email verification flow within the authzn stack
 */
export const postEmailVerificationFlow = createHttpEndpoint<
  PostEmailVerificationResponse,
  PostEmailVerificationRequest
>({
  method: 'POST',
  operationId: 'startEmailVerificationFlow',
  path: '/auth/email-verification/start-flow',
})
